/* eslint-disable no-unused-vars */
// eslint-disable-next-line no-shadow
export enum Path {
  Home = '/',
  Login = '/login',
  NewRegister = '/register',
  // NewRegister = '/new-register',
  ResetPassword = '/reset-password',
  ChangePassword = '/change-password',
  Dashboard = '/dashboard',
  SendMoney = '/send',
  Cards = '/cards',
  TransferHistory = '/transfers',
  ViewTransfer = '/transfers/:txRef',
  ViewGiftTransfer = '/transfers/gift/:txRef',
  Recipients = '/recipients',
  NewRecipient = '/recipients/new',
  ViewRecipient = '/recipients/:recipientId',
  Profile = '/profile',
  VerifyEmail = '/verify-successful',
  Referrals = '/referrals',
  TransferSchedule = '/scheduled-transfers',
  AddTransferSchedule = '/scheduled-transfers/add',
  Veriff = '/veriff',
  Connect = '/connect',
  CuratedPage = '/connect/curated-list',
  ConnectMarketPlace = '/connect/marketplace',
  Checkout = '/checkout',
  ConnectProductPage = '/connect/product/:id',
  VolumeCallback = '/volume-callback',
  ModulrCallback = '/modulr-callback',
  StripeCallback = '/stripe-callback',
  PaymentCallback = '/payment-callback',
  PaymentSuccess = '/payment-success',
  DealsAndRewards = '/deals-and-rewards'
}
